import React from 'react';

interface RecruitmentCardProps {
  children: React.ReactNode;
  boxShadow?: string;
  className?: string | number;
  backgroundColor?: string;
  toolTipTitle?:string,
  padding?: string | number;
}

const RecruitmentCard: React.FC<RecruitmentCardProps> = ({
  children,
  boxShadow,
  className,
  backgroundColor,
  toolTipTitle,
  padding
}) => {
  const RecruitmentCardStyle: React.CSSProperties = {
    boxShadow,
    backgroundColor,
    padding
  };

  return (
    <>
      <div style={RecruitmentCardStyle} className={`${className}`} title={toolTipTitle}>
        {children}
      </div>
    </>
  );
};

export default RecruitmentCard;